import Swiper, { Autoplay, EffectCreative, Navigation, Pagination } from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const sliderReviews = document.querySelector(".slider-reviews__slider");

  if (sliderReviews) {
    const slides = sliderReviews.querySelectorAll(".slider-reviews__slide");
    if(slides.length < 4){
      sliderReviews.classList.add('slider-centered')
    }
    const slider = new Swiper(sliderReviews, {
      modules: [Navigation, Autoplay, EffectCreative, Pagination],
      loop: false,
      speed: 1000,
      spaceBetween: 20,
      navigation: {
        nextEl: ".slider-reviews__nav-btn-next",
        prevEl: ".slider-reviews__nav-btn-prev",
      },
      pagination: {
        el: ".slider-reviews__pagination",
        clickable: true,
        bulletClass: "slider-reviews__pagination pagination__item",
        bulletActiveClass: "pagination__item--active",
      },
      slidesPerView: 1,
      slidesPerGroup: 1,
      autoHeight: true,
      breakpoints: {
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        779: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
    });


  }
});
